export const ANNOTATION_WIDTH = 10;
export const ANNOTATION_DELTA = ANNOTATION_WIDTH * 0.5;

export const PATH_STROKE_WIDTH = 0.75;
export const PATH_STROKE_DELTA = PATH_STROKE_WIDTH * 0.5;
